<template>
  <div v-if="isLoggedIn">
    <a :href="$ceres.urls.myAccount">
      <svg xmlns="http://www.w3.org/2000/svg" width="18.5" height="20" viewBox="0 0 18.501 20">
        <path id="user-solid" d="M9.251,10a5.149,5.149,0,0,0,5.286-5A5.149,5.149,0,0,0,9.251,0,5.149,5.149,0,0,0,3.965,5,5.149,5.149,0,0,0,9.251,10Zm2.094,1.875H7.157A6.972,6.972,0,0,0,0,18.646,1.4,1.4,0,0,0,1.431,20H17.07A1.392,1.392,0,0,0,18.5,18.646,6.972,6.972,0,0,0,11.344,11.876Z" fill="#fff"/>
      </svg>
      <span>{{ $translate("Ceres::Template.myAccountHello", {"username": username }) }}</span>
    </a>
  </div>
  <div class="login-leftmodal login-leftmodal-trigger" v-else-if="!isLoggedIn">
    <a>
      <svg xmlns="http://www.w3.org/2000/svg" width="18.5" height="20" viewBox="0 0 18.501 20">
        <path id="user-solid" d="M9.251,10a5.149,5.149,0,0,0,5.286-5A5.149,5.149,0,0,0,9.251,0,5.149,5.149,0,0,0,3.965,5,5.149,5.149,0,0,0,9.251,10Zm2.094,1.875H7.157A6.972,6.972,0,0,0,0,18.646,1.4,1.4,0,0,0,1.431,20H17.07A1.392,1.392,0,0,0,18.5,18.646,6.972,6.972,0,0,0,11.344,11.876Z" fill="#fff"/>
      </svg>
      <span>{{ $translate("Ceres::Template.login") }}</span>
    </a>
  </div>
</template>

<script>
import ValidationService from "../../../services/ValidationService";
import { mapGetters, mapActions } from "vuex";

export default {
    props: {
        showRegistration: {
            type: Boolean,
            default: true
        },
        showLogin: {
            type: Boolean,
            default: true
        }
    },

    computed: {
        ...mapGetters([
           "username",
           "isLoggedIn"
        ])
    },

    data()
    {
        return {
            isLogin: App.templateType === "login",
            isRegister: App.templateType === "register"
        };
    },

    methods: {
        unmarkInputFields()
        {
            ValidationService.unmarkAllFields($("#login"));
            ValidationService.unmarkAllFields($("#registration"));
        },

        createLoginModal()
        {
            this.loadComponent("login-modal");
        },

        createRegisterModal()
        {
            this.loadComponent("register-modal");
        },

        ...mapActions([
            "loadComponent"
        ])
    }
}
</script>
